import SlideshowButton from '../../SlideshowButton';

export default SlideshowButton;
